export default __webpack_public_path__ + "static/media/bit7.2a234172.svg";